// Old page addresses that the live (Drupal) site redirects to a page's current address.
// Page bodies and outside links still use them, so they are sent on the same way here.
// Keys and values are paths without the leading slash; '' is the site root.
export const PAGE_REDIRECTS = {
  'athlete-representation-certificate': 'sports-agent-advanced-certificate',
  'collegecredit.asp': 'courses/earn-college-credit',
  'conferences/MLS-NSCAA-sports-career-conference': 'conferences/MLS-sports-career-conference',
  'conferences/mls-preseason-meet-and-greet': 'conferences/mls-preseason-soccer-career-conference',
  'conferences/vegas-summer-league-sports-career-conference': 'LasVegas-Basketball-Career-Conference',
  'content/basketball-analytics': 'courses/basketball-analytics',
  'content/basketball-analytics/faq': 'courses/basketball-analytics',
  'content/digital-video-editing-synergy': 'courses/basketball-video-performance-analysis-synergy',
  'content/hockey-analytics': 'courses/hockey-analytics',
  'content/hockey-analytics/faq': 'courses/hockey-analytics',
  'content/sports-agent-course-faq': 'courses/athlete-management/faq',
  'content/sports-management-degrees': 'content/sports-leadership-degrees',
  'course/salary-cap-analysis': 'courses/salary-cap-analysis',
  'course/salary-cap-analysis/faq': 'courses/salary-cap-analysis/faq',
  'courses/athlete-management-sports-agent/faq': 'courses/athlete-management/faq',
  'courses/athlete-management-sports-agent/salaries': 'program/salaries',
  'courses/digital-video-editing': 'courses/football-video-performance-analysis-catapult',
  'courses/digital-video-editing/faq': 'courses/football-video-performance-analysis-catapult/faq',
  'courses/digital-video-editing-hockey': 'courses/hockey-video-performance-analysis-catapult',
  'courses/digital-video-editing-synergy': 'courses/basketball-video-performance-analysis-synergy',
  'courses/proficiency-in-pff-ultimate': 'courses/proficiency-in-pff-premium',
  'courses/proficiency-in-pff-ultimate/faq': 'courses/proficiency-in-pff-premium',
  'courses/soccer-management': 'courses/soccer-scouting',
  'courses/soccer-management/faq': 'courses/soccer-scouting/faq',
  'courses/soccer-talent-identification': 'courses/soccer-player-development',
  'courses/soccer-talent-identification/faq': 'courses/soccer-player-development/faq',
  // The older Sports Agent FAQ (node 1094, still kept here) gave way to node 186563's
  'courses/sports-agent/faq': 'courses/athlete-management/faq',
  'courses/sports-betting': 'courses/sports-cryptocurrency',
  'courses/sports-betting/faq': 'courses/sports-cryptocurrency',
  'courses/sports-marketing-communications': 'courses/sports-media-content-strategy',
  'courses/sports-marketing-communications/faq': 'courses/sports-media-content-strategy/faq',
  'courses/sports-product-marketing': 'courses/athletic-design-manufacturing',
  'courses/sports-product-marketing/faq': 'courses/athletic-design-manufacturing/faq',
  'courses/sports-revenue-management': 'courses',
  'courses/sports-revenue-management/faq': 'courses',
  'directors': 'staff',
  // The Global Ambassador list's old address (live's ambassador bio pages still link it)
  'globalambassadors': 'program/global-ambassadors',
  // The home page's own address (the About Us menu links it)
  'home_page': '',
  'military-discount': 'gi-bill-sports-management',
  'mixed-martial-arts-course': 'courses/mixed-martial-arts-course',
  'nbasummerleaguesportscareerconference.asp': 'LasVegas-Basketball-Career-Conference',
  'sports-management-degrees': 'sports-management-masters-degree',
  'sportsjobstraining.asp': 'courses',
  'talk-with-dr-lashbrook': 'talk-with-dr-lynn-lashbrook',
  // The video analysis course FAQs, which this site kept under these older addresses until
  // page_addresses_from_live.php (backend) moved them to live's
  'courses/digital-video-editing-synergy/faq': 'courses/basketball-video-performance-analysis-synergy/faq',
  'courses/digital-video-editing-hockey/faq': 'courses/hockey-video-performance-analysis-catapult/faq',
  // Live's tag page for Soccer Analytics (taxonomy term 143), whose only content is a link to the
  // course; this site has no tag pages, so it shows the course itself
  'courses/soccer-analytics': 'courses/soccer-analytics-course',
};
